import controller from './pqrs-list.controller';
import template from './pqrs-list.view.html';

let PqrsListComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default PqrsListComponent;



// WEBPACK FOOTER //
// ./www/components/pqrs/pqrs-list/pqrs-list.component.js